import { IconComponent } from '../icon.types';

export const LightningGreenCircle: IconComponent = (props) => (
  <svg
    width="59"
    height="60"
    viewBox="0 0 59 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      y="13"
      width="48"
      height="48"
      rx="24"
      transform="rotate(-15 0 13)"
      fill="#B9DB2E"
    />
    <g clipPath="url(#clip0_499_1810)">
      <path
        d="M33.0465 41.4153L29.3306 42.411L29.1919 34.1659L25.1998 35.2356C24.8139 35.3388 24.4092 35.3504 24.0181 35.2693C23.627 35.1882 23.2603 35.0168 22.9473 34.7687C22.6342 34.5206 22.3836 34.2027 22.2153 33.8405C22.047 33.4782 21.9658 33.0817 21.9782 32.6824L22.4013 19.421L31.5457 16.9708L30.7185 25.4747L34.6044 24.4334C35.0466 24.3152 35.5126 24.3191 35.9527 24.4446C36.3929 24.57 36.7909 24.8124 37.1043 25.146C37.4178 25.4795 37.635 25.8918 37.7329 26.3389C37.8307 26.786 37.8056 27.2513 37.6602 27.6853L33.0465 41.4153Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_499_1810">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(14.6968 21.4854) rotate(-15)"
        />
      </clipPath>
    </defs>
  </svg>
);
